<template>
  <require from="framework/value_converters/date-and-time"></require>
  <require from="controls/bs-form-input"></require>
  <require from="controls/bs-form-select"></require>

  <div class="trips-common-filter">
    <div class="form-row">
      <div class="col-sm-6 col-lg order-sm-0 order-lg-0">
        <bs-form-input type="text" label="Trip name, traveller or country" placeholder="Type to search" value.bind="model.text & debounce:debounceMs" maxlength="100"></bs-form-input>
      </div>
      <div class="col-sm-6 col-lg order-sm-1 order-lg-1">
        <bs-form-input type="date" label="From" value.bind="model.from | dateInput & debounce:debounceMs"></bs-form-input>
      </div>
      <div class="col-sm-6 col-lg order-sm-3 order-lg-2">
        <bs-form-input type="date" label="To" value.bind="model.to | dateInput & debounce:debounceMs"></bs-form-input>
      </div>
      <div class="col-sm-6 col-lg order-sm-2 order-lg-3">
        <bs-form-select label="Archive" value.bind="model.includeArchived" options.bind="archiveOptions" value-path="value" name-path="name"></bs-form-select>
      </div>
    </div>
  </div>
</template>
